export default {
  "welcome": {
    "welcome-to": "Bem-vindo ao",
    "one-philly": "Uma Filadélfia,",
    "united-city": "Uma cidade unida!",
  },
  "city-offices": {
    "city-offices-title": "Escritórios municipais",
    "city-offices-text-1": "Os escritórios municipais estão abertos em horário comercial normal. Alguns serviços estão sendo oferecidos on-line ou com hora marcada. Para saber mais, ",
    "city-offices-text-2": "verifique com seu departamento de interesse.",
    "city-offices-closure-text": "",
    "trash-title": "Lixo e reciclagem",
    "trash-text-1": "As coletas de lixo e reciclagem estão em um cronograma de feriados. Estabeleça os materiais um dia antes do seu dia normal.",
    "trash-text-2": "Para saber mais, ",
    "trash-text-3": "verifique a programação de feriados.",
    "trash-closure-text": "",
  },
  "services": {
    "trash": "Encontre seu dia de lixo",
    "bill": "Pague uma conta",
    "jobs": "Explore empregos na cidade",
    "property": "Pesquise uma propriedade",
    "taxes": "Arquive e pague impostos municipais",
    "recycle": "Recicle as folhas de outono",
    "visit": "Visite uma pessoa encarcerada",
    "license": "Obtenha uma licença",
    "popular-services": "Serviços populares",
    "jump-to-all-services": "Ir para todos os serviços",
    "services-by-topic": "Serviços por tópico",
    "see-all-services": "Veja todos os serviços",
    "alerts": "Inscreva-se para receber alertas de emergência",
  },
  "tools": {
    "parks-finder": "Localizador de parques e recreação",
    "contracts": "Hub de contratos",
    "school-time-activity": "Localizador de atividades fora do horário escolar",
    "food-meal": "Localizador gratuito de alimentos e refeições",
    "atlas": "Atlas",
    "primary": "Localizador de cuidados primários",
    "eclipse": "eCLIPSE",
    "mail-vote-remind": "Lembrete de votação por e-mail",
    "street-smart": "StreetSmartPHL",
    "commonly-used-tools": "Ferramentas comumente usadas",
    "see-all-tools": "Veja todas as ferramentas",
  },
  "news": {
    "featured-news": "Notícias em destaque",
    "see-all-news": "Veja todas as notícias",
  },
  "311": {
    "report-311": "Ajude a tornar a Filadélfia a cidade grande mais segura, limpa e verde do país. Relate terrenos vagos, grafites, automóveis abandonados e muito mais para Philly311.",
    "report-problem": "RELATAR UM PROBLEMA",
    "track-request": "RASTREAR UMA SOLICITAÇÃO",
    "ask-question": "FAÇA UMA PERGUNTA",
  },
  "stay-connected": {
    "stay-connected": "Permaneça conectado",
    "sign-up-email": "Inscreva-se para receber atualizações por e-mail da cidade da Filadélfia",
    "sign-up": "Cadastre-se",
  },
  "footer": {
    "elected-officials": "Funcionários eleitos",
    "mayor": "Prefeito",
    "city-council": "Câmara Municipal",
    "courts": "Tribunais",
    "district-attorney": "Procurador Distrital",
    "city-controller": "Controlador da cidade",
    "sheriff": "Xerife",
    "city-commissioners": "Comissários municipais",
    "register-wills": "Registro de testamentos",
    "open-govt": "Governo aberto",
    "code-charter": "Código e Carta da Filadélfia",
    "city-records": "Registros da cidade",
    "city-agency-regs": "Regulamentos de agências municipais",
    "executive-orders": "Ordens executivas",
    "honesty-govt": "Honestidade no governo",
    "voting-elections": "Votação e eleições",
    "open-data": "Dados abertos",
    "org-chart": "Organograma da cidade",
    "explore-phila": "Explore a Filadél",
    "visit-phila": "Visite Filadélfia",
  },
  "clean-green": {
    "clean-green": "Limpo e verde ",
    "clean-green-statement": "Nossa cidade está se unindo para tornar a Filadélfia a cidade grande mais segura, limpa e verde do país, com oportunidades econômicas para todos. Siga a estratégia municipal que aborda os problemas de qualidade de vida em todos os bairros.",
    "blocks-swept": "Blocos varridos",
    "abandoned-autos": "Automóveis abandonados removidos",
    "properties-cleaned": "Propriedades limpas e seladas",
    "graffiti-removed": "Grafite removido",
    "see-all-clean-green": "VEJA TUDO LIMPO E VERDE",
  },
  "mayor": {
    "mayor-details": "Cherelle L. Parker é a 100ª prefeita da Filadélfia e a primeira mulher a ocupar esse cargo em 341 anos. Moradora vitalícia da cidade, ela está comprometida em lutar todos os dias pelos habitantes da Filadélfia.",
    "learn-more": "Saiba mais",
  },
  "city-council": {
    "city-council": "Conselho Municipall",
    "district-council-member": "Membro do Conselho Distrital",
    "council-member-al":  "Membro do Conselho At-Large",
    "council-president": "Presidente do Conselho",
    "dep-majority-whip": "Vice-chefe da maioria",
    "majority-whip": "Chicote da maioria",
    "minority-leader": "Líder minoritário",
    "minority-whip": "Chicote minoritário",
    "majority-leader": "Líder da maioria",
  }, 
  "philly-stat-360": {
    "ps360": "Estado da Filadélfia 360",
    "data-subheader": "Transformando dados em ações para nossas comunidades.",
  },
};